import * as React from "react"
const StarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#ACACAC"
      d="M12.978 16.044 8 12.385l-4.978 3.659 1.911-5.909L-.042 6.5h6.143L8 .581 9.9 6.5h6.141l-4.974 3.635 1.911 5.909ZM8 10.731l2.439 1.792-.934-2.896 2.453-1.794H8.927L8 4.946l-.927 2.887H4.041l2.456 1.794-.934 2.896L8 10.731Z"
    />
  </svg>
)
export default StarIcon
